var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"steps"},[_c('el-steps',{attrs:{"active":_vm.active}},_vm._l((_vm.options),function(option,index){return _c('el-step',{key:index,attrs:{"title":option}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }